import { Component, OnChanges, OnDestroy } from '@angular/core';
import { Input, Output, EventEmitter } from '@angular/core';
import { ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';

import { Subscription } from 'rxjs';

import { PlacePanel } from '@unpispas/upp-base';
import { ViewRenderer } from '@unpispas/upp-wdgt';

import { alertService } from '@unpispas/upp-base';
import { languageService, languageSupport } from '@unpispas/upp-base';
import { dataService } from '@unpispas/upp-data';
import { viewService } from '@unpispas/upp-base';

import { QrCodeView } from '@unpispas/upp-data';

/****************************/
/* TICKET QRCODE DISPLAY    */
/****************************/

class TicketQrCodeDisplay {
    constructor(private qrcode: QrCodeView){
        // nothing to do
    }

    /* access to calculated values */

    get alias(): string | null {
        return (this.qrcode?.alias) || null;
    }

    get number(): number {
        return (this.qrcode?.number) || 0;
    }

    get amount(): number {
        if (!this.qrcode){
            return 0;
        }

        let _amount = 0;
        for(const ticket of this.qrcode.tickets){
            if (ticket.IsRecent && ticket.IsOpened){
                _amount++;
            }
        }
        return _amount;
    }

    get extras(): boolean {
        return (this.qrcode?.extras.length > 0) || false;
    }
}

/****************************/
/* UPP-EXTRA-TICKET         */
/****************************/

@Component({
    selector: 'upp-qrcode-ticket',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './upp-ticket.html',
    styleUrls: [
      './upp-ticket.scss'
    ],
    providers: [{
        provide: ViewRenderer,
        useFactory: (change: ChangeDetectorRef) => new ViewRenderer(change),
        deps: [ChangeDetectorRef]
    }]       
})
export class UppQrCodeTicketComponent extends languageSupport implements OnChanges, OnDestroy {
    @Input() qrcode: QrCodeView | null = null;

    @Output() ToPanel = new EventEmitter<PlacePanel>();

    private _qrcode_subscription: Subscription | null = null;

    constructor(private lang: languageService, private change: ViewRenderer, private alertCtrl: alertService, private data: dataService, public view: viewService){
        super(lang, change.cdref);
    }    

    ngOnChanges(){
        if (this._qrcode_subscription){
            this._qrcode_subscription.unsubscribe();
            this._qrcode_subscription = null;
        }

        if (this.qrcode){
            this._qrcode_subscription = this.qrcode.OnViewRefresh.subscribe(
            () => {
                if (this.display){
                    this.change.markForCheck();
                }
            });
        }
    }

    ngOnDestroy(): void {
        super.OnDestroy();

        if (this._qrcode_subscription){
            this._qrcode_subscription.unsubscribe();
            this._qrcode_subscription = null;
        }
    }   
    
    /********************************/
    /* DISPLAY OPTIONS              */
    /********************************/    
    
    private _display: TicketQrCodeDisplay | null = null; 
    get display() : TicketQrCodeDisplay | null {    
        if (this._display === null){
            if (this.qrcode != null){
                this._display = new TicketQrCodeDisplay(this.qrcode);
            }
        }

        return this._display;
    }
}